import { useParams } from "react-router-dom";
import { useGetBarcodeListQuery } from "../features/CallApi"
import { QrGenerator } from "./QrGenerator"
import LoadScreen from "./UI/LoadScreen";
import { Container } from "reactstrap";


export const QrCodeList = () => {
    const { id } = useParams();
    const { data } = useGetBarcodeListQuery(id)

    return (
        <Container>
            {data ?
                <div>
                    {data.map(item =>
                        <div className="border-1 border" key={item.id}>
                            <QrGenerator barcode={item.barcode} />
                            <div className="p-1">
                                <div>ID в системе: {item.id}</div>
                                <div>Содержимое ШК:{item.barcode}</div>
                            </div>
                        </div>
                    )}
                </div> : <LoadScreen />
            }
        </Container>

    )

}